export const SearchIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.3533 12.646L10.224 9.51668C11.02 8.56268 11.5 7.33667 11.5 6C11.5 2.96733 9.03267 0.5 6 0.5C2.96733 0.5 0.5 2.96733 0.5 6C0.5 9.03267 2.96733 11.5 6 11.5C7.33667 11.5 8.56266 11.02 9.51666 10.224L12.646 13.3534C12.7433 13.4507 12.8713 13.5 12.9993 13.5C13.1273 13.5 13.2553 13.4514 13.3527 13.3534C13.5487 13.158 13.5487 12.8413 13.3533 12.646ZM1.5 6C1.5 3.51867 3.51867 1.5 6 1.5C8.48133 1.5 10.5 3.51867 10.5 6C10.5 8.48133 8.48133 10.5 6 10.5C3.51867 10.5 1.5 8.48133 1.5 6Z'
        fill='currentColor'
        stroke='currentColor'
      />
    </svg>
  )
}
